import { render, staticRenderFns } from "./SimpleInput.vue?vue&type=template&id=566bd0f6&scoped=true&"
import script from "./SimpleInput.vue?vue&type=script&lang=js&"
export * from "./SimpleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bd0f6",
  null
  
)

export default component.exports